<script>
import { Bar } from 'vue-chartjs'
import Utils from './Utils'
const utils = new Utils()
export default {
  name: 'ChartBar',
  extends: Bar,
  props: {
    columns: {
      type: Array,
      default: () => (
        [
          { label: 'first-column', key: '1' },
          { label: 'second-column', key: '2' }
        ])
    },
    labelKey: { type: String, default: 'x' },
    labels: {
      type: Array,
      default: () => (
        [
        ]
      )
    },
    data: {
      type: Array,
      default: () => (
        [
          { x: '', y: '', columnKey: '1' },
          { x: '', y: '', columnKey: '2' }
        ]
      )
    },
    options: { type: Object, default: () => ({}) },
    getDataSetPayload: { type: Function, default: () => ({ backgroundColor: utils.getColor(), fill: false }) }
  },
  methods: {
    prepareDataset (data) {
      return this.columns.map(({ label, key }) => {
        return {
          label,
          data: this._getDataColumn(key, data),
          ...this.getDataSetPayload()
        }
      })
    },
    _getDataColumn (key, data) {
      const _dataColumn = data.filter(({ columnKey }) => columnKey === key)
      const _data = new Array(this.labels.length).fill(null)
      _dataColumn.forEach((item) => {
        let labelIndex = this.labels.findIndex(label => label === item[this.labelKey])
        _data.splice(labelIndex, 1, this._preparePoint(item))
      })
      return _data
    },
    _preparePoint ({ x, y }) {
      return {
        x,
        y
      }
    },
    // User Interface
    render () {
      const data = {
        labels: this.labels,
        datasets: this.prepareDataset(this.data)
      }
      this.renderChart(data, this.options)
    }
  }
}
</script>
